/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionVipPassWindow = Prefab.createWindow((mission) => Merge2MissionHelper.getBundleName(mission.logic.period), "merge2mission_vippass_window_prefab_json");
